import Permissions from '@views/mixins/Permissions';

export const registerMixins = app => {
  app.mixin(Permissions);
};
